// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_ox-0";
export var buttonContainer = "_ox-3";
export var cancelButton = "_ox-4";
export var headerSection = "_ox-6";
export var headerTitle = "_ox-9";
export var messageSideLeft = "_ox-1";
export var messageSideRight = "_ox-2";
export var orderNumberContainer = "_ox-7";
export var orderNumberLabel = "_ox-8";
export var submitButton = "_ox-5";